import clsx from 'clsx';
import { CSSProperties, MouseEventHandler, PropsWithChildren, forwardRef } from 'react';
import styles from './BadgeLabel.module.scss';

interface BadgeLabelProps extends PropsWithChildren {
  color?: CSSProperties['color'] | undefined;
  backgroundColor?: CSSProperties['backgroundColor'] | undefined;
  display?: 'flex' | 'inline-flex';
  width?: CSSProperties['width'];
  justifyContent?: CSSProperties['justifyContent'] | undefined;
  onClick?: MouseEventHandler<HTMLElement> | undefined;
  className?: string;
  dataTestId?: string;
}

const BadgeLabel = forwardRef<HTMLDivElement, BadgeLabelProps>(
  ({ color, backgroundColor, onClick, display, children, justifyContent, width, dataTestId, className }, ref) => {
    return (
      <div
        className={clsx(styles.container, className)}
        data-testid={dataTestId}
        style={{
          display,
          backgroundColor,
          color,
          width,
          cursor: onClick ? 'pointer' : undefined,
          justifyContent,
        }}
        onClick={onClick}
        ref={ref}
      >
        {children}
      </div>
    );
  },
);

export default BadgeLabel;
